import { EnvConfig } from '../../types/window';
import config from './index.build-dev';

/**
 * During the build process, the index.build-dev.ts file will be replaced with index.build-prod.ts
 * import config from './index.build-dev';
 * replace configuration in angular.json
 * "fileReplacements": [
    {
      "replace": "src/app/env-config/index.build-dev.ts",
      "with": "src/app/env-config/index.build-prod.ts"
    }
  ]
 */

// index.build-dev file will be replaced with index.build-prod during the build process
// More details: https://engjira.int.kronos.com/browse/PS-451187

// Merge dev/prod config with runtime config from window.envData
// Dev config provides defaults, runtime config (if any) can override
const envConfig: EnvConfig = {
  ...config, // Dev/prod defaults (includes useMockData)
  ...(window.envData?.envConfig ?? {}), // Runtime overrides
};

// Reinitialize window.envData.envConfig with merged config
window.envData.envConfig = envConfig;
export default envConfig;
